export default {
  labs: [],
  loading: false,
  total: 0,
  FilteredCount: 0,
  labProducts: []
}
